import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { MaskitoOptions } from '@maskito/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { masks } from 'src/app/services/input-masks';

@Component({
  selector: 'app-text-question',
  templateUrl: './text-question.component.html',
  styleUrls: ['./text-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class TextQuestionComponent implements OnInit, OnDestroy {

  @Input() question: QQQuestionViewModel;
  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  mask: MaskitoOptions;
  dispose$ = new Subject();

  ngOnInit() {
    if (this.question.options?.mask)
      this.mask = masks[this.question.options?.mask];
    else
      this.mask = masks['any'];

    this.question.beforeSubmit(
      this.dispose$,
      e => {
        if (this.input.nativeElement.value != this.question.answer)
          e.add(async () => {
            this.question.editingValue = this.input.nativeElement.value;
            return await this.save();
          })
      });
  }

  ngOnDestroy(): void {
    this.dispose$.next(null);
  }

  async save() {
    if (!this.question.editingValue) {
      this.question.error = 'Please enter a value';
      return;
    }

    return await this.question.setAnswer(this.question.editingValue, true);
  }
}
